export const toEmbedUrl = (url: string) => {
  const embedUrl = new URL(url);
  embedUrl.pathname += embedUrl.pathname.endsWith('/') ? 'embed' : '/embed';
  embedUrl.search = '';
  embedUrl.hash = '';

  return embedUrl.toString();
};
